/* eslint-disable */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useCallback } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button, Grid, Paper, IconButton, Card,
} from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { FiPlusCircle } from 'react-icons/fi';
import { FaLinkedin, FaGithub, FaFacebook, FaTwitter, FaTelegram } from "react-icons/fa";
import { FaSquareArrowUpRight } from "react-icons/fa6";
import { MdCancel } from "react-icons/md";
import { FcApproval } from "react-icons/fc";
import { ExpandUpIcon } from 'src/icons';
import Input from 'src/components/elements/Input';
import RHFInput from 'src/components/elements/Input/RHFInput';
import RHFPhoneInput from 'src/components/elements/Input/RHFPhoneInput';
import RHFSelect from 'src/components/elements/Select/RHFSelect';
import { Option } from 'src/components/elements/Select';
import useYupValidationResolver from 'src/hooks/useYupValidationResolver';
import { CurrencyType, CandidateDetails, CandidateInformationFormComponent } from '../../types';
import RHFDOBInput from 'src/components/elements/Input/RHFDOBInput';
import { Option as CurrencyOption, options as currencyOptions } from 'src/components/elements/Input';
import { useVendors } from 'src/hooks/query/vendors';
import RHFAutoComplete from 'src/components/elements/AutoComplete/RHFAutoComplete';
import { ContactInfo, Vendor } from 'src/pages/ViewJob/types';
import { scrollToError } from 'src/utils/FormUtils';
import AddAndRefreshConsultancyOptions from 'src/pages/ViewJob/components/AddAndRefreshConsultancyOptions';
import { AuthProvider } from '@panna/auth';
import Requests from 'src/network/accounts';
import { useLocations } from 'src/hooks/query/locations';
import { useJobTypes } from 'src/hooks/query/job-types';

const defaultCollapsibleSections = [{
  name: 'Basic Details',
  expanded: true,
},
{
  name: 'Consultancy Details',
  expanded: true,
},
{
  name: 'Additional Details',
  expanded: true,
},
{
  name: 'Source & Comment',
  expanded: true,
}];

function CandidateInformationForm(props: CandidateInformationFormComponent) {
  const {
    profileInfo,
    payTypes,
    resumeSources,
    workAuthorizations,
    updateProfileInfo,
  } = props;

  const relocationOptions = [
    {label: 'YES', value: 'YES'},
    {label: 'NO', value: 'NO'},
  ]

  const experienceOptions = [
    {label: 'Beginner (0-2 years)', value: 'Beginner (0-2 years)'},
    {label: 'Advanced (2-5 years)', value: 'Advanced (2-5 years)'},
    {label: 'Expert(5+ years)', value: 'Expert(5+ years)'},
  ];

  const [selectedCurrency, setSelectedCurrency] = useState<CurrencyOption>(currencyOptions.find((option) => option.currencyName === profileInfo?.currency) || { currencyName: '', currencyIcon: '' });
  const [socialLinkInput, setSocialLinkInput] = useState<string>('');
  const [showSocialLink, setShowSocialLink] = useState<boolean>(false);
  const [socialLinks, setSocialLinks] = useState<string[]>([]);
  const [collapsibleSections, setCollapsibleSections] = useState(defaultCollapsibleSections);
  const [contactOptions, setContactoptions] = useState<Option<string, string>[]>([]);
  const [consultancyContactInfo, setConsultancyContactInfo] = useState<ContactInfo[]>([]);

  const {fetchVendors, vendorOptions} = useVendors();


  const validationSchema = yup.object().shape({
    firstName: yup.string().typeError('Enter valid First name')
    .required('First Name is required'),
    lastName: yup.string().typeError('Enter valid Last name').required('Last Name is required'),
    candidateLocation: yup.string().typeError('Enter valid Location')
    .required('Location is required'),
    resumeSource: yup.string().typeError('Enter valid source')
    .required('Source is required'),
    emailAddress: yup.string().email('Enter valid Email Address').required('Email Address is required'),
    consultancyEmailAddress: yup
    .string()
    .email(),
    consultancyId: yup
    .string()
    .when(['payType'], (values, schema) => {
      const payTypeSelected = values[0];
      const matchingPayType = payTypesArray.find((payType) => payType.value === payTypeSelected);
      const isC2C = matchingPayType ? matchingPayType.label.toLowerCase().includes('c2c') : false;
      return isC2C
        ? schema.required('Consultancy Name required')
        : schema.notRequired();
    }),
    consultancyContactId: yup
    .string()
    .when(['payType'], (values, schema) => {
      const payTypeSelected = values[0];
      const matchingPayType = payTypesArray.find((payType) => payType.value === payTypeSelected);
      const isC2C = matchingPayType ? matchingPayType.label.toLowerCase().includes('c2c') : false;
      return isC2C
        ? schema.required('Consultancy Contact Person required')
        : schema.notRequired();
    }),
    consultancyPhoneNumber: yup
    .string(),
    extensionNumber: yup
    .string(),
    payRate: yup.number().transform((value) => (isNaN(value) ? undefined : value)).typeError('Enter valid pay rate').nullable().notRequired(),
    comments: yup
      .string()
      .typeError('Enter Valid Comments')
      .when(['resumeSource'], (values, schema) => {
        const source = values[0];
        return source !== profileInfo?.resumeSource
          ? schema.required('Comments required')
          : schema.notRequired();
      }),
  });

  const methods = useForm<CandidateDetails>({
    defaultValues: {
      candidateTitle: '',
      payType: '',
      payRate: '',
      consultancyId: '',
      consultancyContactId: '',
      consultancyPhoneNumber: '',
      extensionNumber: '',
      consultancyEmailAddress: '',
      firstName: '',
      middleName: '',
      lastName: '',
      reLocation: '',
      candidateLocation: '',
      experienceLevel: '',
      emailAddress: '',
      phoneNumber: '',
      dateOfBirth: '',
      visaStatus: '',
      resumeSource: '',
      comments: '',
      currency: currencyOptions[0].currencyName,
    },

    resolver: useYupValidationResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    watch,
    setValue,
    clearErrors,
    formState: {isDirty},
  } = methods;

  const submitHandler = (data: CandidateDetails) => {
    const requestObj = {
      payRate: data.payRate,
      payType: data.payType,
      middleName: '',
      candidateTitle: data.candidateTitle,
      consultancyId: data.consultancyId,
      consultancyContactId: data.consultancyContactId,
      consultancyPhoneNumber: data.consultancyPhoneNumber,
      extensionNumber: data.extensionNumber,
      consultancyEmailAddress: data.consultancyEmailAddress,
      firstName: data.firstName,
      lastName: data.lastName,
      reLocation: data.reLocation,
      candidateLocation: data.candidateLocation,
      experienceLevel: data.experienceLevel,
      emailAddress: data.emailAddress,
      phoneNumber: data.phoneNumber,
      dateOfBirth: data.dateOfBirth,
      visaStatus: data.visaStatus,
      resumeSource: data.resumeSource,
      comments: data.comments,
      socialLinks: socialLinks.toString(),
      currency: selectedCurrency.currencyName,
    };
    updateProfileInfo(requestObj);
  };

  const getConsultancyDetails = useCallback(async () => {
    try {
      const consultancyId = watch("consultancyId");
      if (!consultancyId) {
        setValue('consultancyContactId', '');
        setValue("consultancyPhoneNumber", "");
        setValue("extensionNumber", "");
        setValue("consultancyEmailAddress", "");
        setContactoptions([]);
        return;
      }
      
      const res = await Requests.getInstance().getConsultancyById(consultancyId);
      const contactInfo = res.data.contactInfo;
      const contactOptions = contactInfo?.map((item: ContactInfo) => ({
        label: item.name,
        value: item.id?.toString() || '0',
      })) || [];
  
      setConsultancyContactInfo(contactInfo || []);
      setContactoptions(contactOptions);
  
      if (isDirty) {
        if (contactOptions.length === 1) {
          setValue('consultancyContactId', contactOptions[0].value);
          clearErrors('consultancyContactId');
        } else {
          setValue('consultancyContactId', '');
        }
      }
    } catch (e) {
      console.info('error occurred while fetching consultancyById', e);
    }
  }, [watch("consultancyId"), setValue, clearErrors, isDirty]);

  useEffect(() => {
    getConsultancyDetails();
  }, [getConsultancyDetails]);

  useEffect(() => {
    reset({
      candidateTitle: profileInfo?.candidateTitle,
      payType: profileInfo?.payType,
      payRate: profileInfo?.payRate,
      consultancyId: profileInfo?.consultancyId,
      consultancyContactId: profileInfo?.consultancyContactId,
      consultancyPhoneNumber: profileInfo?.consultancyPhoneNumber,
      extensionNumber: profileInfo?.extensionNumber,
      consultancyEmailAddress: profileInfo?.consultancyEmailAddress,
      firstName: profileInfo?.firstName,
      middleName: profileInfo?.middleName,
      lastName: profileInfo?.lastName,
      reLocation: profileInfo?.reLocation,
      candidateLocation: profileInfo?.candidateLocation,
      experienceLevel: profileInfo?.experienceLevel,
      emailAddress: profileInfo?.emailAddress,
      phoneNumber: profileInfo?.phoneNumber,
      dateOfBirth: profileInfo?.dateOfBirth,
      visaStatus: profileInfo?.visaStatus,
      resumeSource: profileInfo?.resumeSource,
      comments: profileInfo?.comments,
      currency: profileInfo?.currency,
    });
    setSelectedCurrency(currencyOptions.find((option) => option.currencyName === profileInfo?.currency) || { currencyName: '', currencyIcon: '' });
    if (profileInfo) {
      if (profileInfo?.socialLinks && profileInfo?.socialLinks !== '') {
        const links = profileInfo?.socialLinks.split(',');
        setSocialLinks(links);
      }
    }
  }, [profileInfo]);

  useEffect(() => {
    if (!vendorOptions?.length) fetchVendors();
  }, []);

  useEffect(()=>{
      const contactPersonNameId = watch("consultancyContactId");
      const contactPerson = consultancyContactInfo?.find((item)=>item?.id?.toString() === contactPersonNameId);
      setValue("consultancyPhoneNumber", contactPerson?.phoneNumber || "");
      setValue("extensionNumber", contactPerson?.extensionNumber || "");
      setValue("consultancyEmailAddress", contactPerson?.emailAddress || "");
  },[watch("consultancyContactId"), contactOptions]);

  const addSocialLink = () => {
    if (socialLinkInput.includes('.com')) {
      const formattedInput = socialLinkInput.toLowerCase().replace('www.', '');
      const linkInput = formattedInput.replace('.com', '');
      if (!profileInfo?.socialLinks?.includes(linkInput)) {
        const updatedSocialLinks = [...socialLinks];
        updatedSocialLinks.push(socialLinkInput.toLowerCase());
        setSocialLinks(updatedSocialLinks);
        setSocialLinkInput('');
        setShowSocialLink(false);
      }
    }
  }

  const payTypesArray: Option<string, string>[] = payTypes.map((each) => ({
    label: each.name,
    value: (each.id).toString(),
  }));

  const {jobTypesOptions} = useJobTypes();

  const {locationsOptions} = useLocations();

  const sourcesArray: Option<string, string>[] = resumeSources.map((each) => ({
    label: each,
    value: each,
  }));

  const workAuthorizationsArray: Option<string, string>[] = workAuthorizations.map((each) => ({
    label: each,
    value: each,
  }));
  

  const openSocialLink = (link: string) => {
    if (!link.includes('http')) {
      window.open('http://'+link, '_blank');
    } else {
      window.open(link, '_blank');
    }
  }

  const handleAccordionChange = (name: string) => {
    const updatedData = collapsibleSections.map(each => {
      if (each.name === name) {
        return {
          ...each,
          expanded: !each.expanded,
        };
      }
      return each;
    });
    setCollapsibleSections(updatedData);
  };

  const getIcon = (link: string) => {
    if (link?.toLowerCase().includes('linkedin.com')) {
      return <FaLinkedin color='blue' />
    } else if (link?.toLowerCase().includes('github.com')) {
      return <FaGithub color='purple' />
    } else if (link?.toLowerCase().includes('facebook.com')) {
      return <FaFacebook color='blue' />
    } else if (link?.toLowerCase().includes('telegram.com')) {
      return <FaTelegram color='blue' />
    } else if (link?.toLowerCase().includes('twitter.com')) {
      return <FaTwitter color='blue' />
    } else {
      return <FaSquareArrowUpRight />
    }
  }

  const onError = () => {
    scrollToError('application-form');
  };

  return (
    <Paper id="application-form" className="p-4 rounded-md text-left bg-inherit" elevation={0}>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(submitHandler)}>
          <div style={{ marginBottom: 8 }}>
            {collapsibleSections.map(each => (
              <Accordion
              expanded={each.expanded}
              onChange={() => handleAccordionChange(each.name)}
              sx={{ mb: 1 }}
              >
                <AccordionSummary
                  expandIcon={<ExpandUpIcon />}
                  aria-controls="content"
                  id="content"
                >
                  <Typography>{each.name}</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ mb: 1 }}>
                  <>
                    {each.name === 'Basic Details' ? (
                      <div>
                        <Grid container spacing={3} mb={4} pl={3}>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <RHFInput control={methods.control} name="firstName" label="First Name" />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <RHFInput control={methods.control} name="lastName" label="Last Name" />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <div className="h-full flex items-end">
                              <RHFAutoComplete
                                control={methods.control}
                                name="candidateTitle"
                                label="Candidate Job Title"
                                options={jobTypesOptions}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <div className="h-full flex items-end">
                              <RHFSelect
                                control={methods.control}
                                name="reLocation"
                                label="Relocation"
                                options={relocationOptions}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <div className="h-full flex items-end">
                              <RHFAutoComplete
                                control={methods.control}
                                name="candidateLocation"
                                label="Location"
                                options={locationsOptions}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <RHFPhoneInput
                              control={methods.control}
                              name="phoneNumber"
                              label="Contact Number"
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <div className="h-full flex items-end">
                              <RHFSelect
                                control={methods.control}
                                name="experienceLevel"
                                label="Experience"
                                options={experienceOptions}
                              />
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={6} lg={3}>
                            <RHFInput
                              control={methods.control}
                              name="emailAddress"
                              label="Email Address"
                              disabled
                            />
                          </Grid>
                        </Grid>
                        {socialLinks && socialLinks.length > 0 && socialLinks.map((each) => {
                          return (
                            <IconButton onClick={() => openSocialLink(each)}>
                              {getIcon(each)}
                            </IconButton>
                          )
                        })}
                        <div className="pl-5 mt-2 pt-0 mb-2">
                          <Button
                            variant="text"
                            startIcon={<FiPlusCircle />}
                            onClick={() => setShowSocialLink(true)}
                          >
                            Add Social Link
                          </Button>
                        </div>
                        {showSocialLink && (
                          <Grid container spacing={3} mb={4} pl={3}>
                            <Grid item xs={12} sm={12} md={6} lg={3}>
                              <Input
                                value={socialLinkInput}
                                onChange={(event: any) => {
                                  setSocialLinkInput(event)
                                }}
                              />
                            </Grid>
                            <Grid display="flex" sx={{ mt: 3 }}>
                              <IconButton
                                onClick={addSocialLink}
                              >
                                <FcApproval color='#F97171' />
                              </IconButton>
                              <IconButton 
                                onClick={() => {
                                  setShowSocialLink(false);
                                  setSocialLinkInput('');
                                }}
                              >
                                <MdCancel color='red' />
                              </IconButton>
                            </Grid>
                          </Grid>
                        )}
                      </div>
                    ) :  each.name === 'Additional Details' ? (
                      <Grid container spacing={3} mb={4} pl={3}>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <RHFDOBInput control={methods.control} name="dateOfBirth" label="D.O.B (mm/dd)" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <div className="h-full flex items-end">
                            <RHFSelect
                              control={methods.control}
                              name="visaStatus"
                              label="Work Authorization"
                              options={workAuthorizationsArray}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <div className="h-full flex items-end">
                            <RHFSelect
                              control={methods.control}
                              name="payType"
                              label="Pay Type"
                              options={payTypesArray}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <RHFInput name="payRate" iconStart={selectedCurrency.currencyIcon || '$'} control={methods.control} label="Pay Rate" onCurrencyChange={(currency: CurrencyOption) => setSelectedCurrency(currency)} />
                        </Grid>
                      </Grid>
                    ) : each.name === 'Consultancy Details' ? (
                      <div className='mb-4'>
                      <Grid container spacing={3} pl={3} mb={2}>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <div className="h-full relative -bottom-[25px] flex items-start">
                            <RHFAutoComplete control={methods.control} name="consultancyId" label="Consultancy Name" options={vendorOptions} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <div className="h-full relative -bottom-[25px]">
                            <RHFAutoComplete control={methods.control} name="consultancyContactId" label="Contact Person" options={contactOptions} />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={8} md={4} lg={2}>
                          <RHFPhoneInput
                            control={methods.control}
                            name="consultancyPhoneNumber"
                            label="Contact Number"
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2} lg={1}>
                            <RHFInput
                              control={methods.control}
                              name="extensionNumber"
                              label="Ext No."
                            />
                          </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <RHFInput control={methods.control} name="consultancyEmailAddress" label="Email Address" disabled />
                        </Grid>
                      </Grid>
                      <div className='pl-4'>
                        <AuthProvider>
                          <AddAndRefreshConsultancyOptions fetchVendors={fetchVendors} />
                        </AuthProvider>
                      </div>
                      </div>
                    ) : (
                      <Grid container spacing={3} mb={4} pl={3}>
                        <Grid item xs={12} sm={12} md={6} lg={3}>
                          <RHFSelect
                            control={methods.control}
                            name="resumeSource"
                            label="Source"
                            options={sourcesArray}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={6} lg={8}>
                          <RHFInput control={methods.control} name="comments" label="Comment" />
                        </Grid>
                    </Grid>
                    )}
                  </>
                </AccordionDetails>
              </Accordion>
            ))}
          </div>
          <Grid display="flex" gap={1}>
            <Button
              variant="contained"
              size="large"
              type="submit"
              sx={{ marginTop: '10px'}}
            >
              Update
            </Button>
          </Grid>
        </form>
      </FormProvider>
    </Paper>
  );
}

export default CandidateInformationForm;
